export interface AustraliaDotsProps {
  className?: string;
}

export const AustraliaDots = ({ className }: AustraliaDotsProps) => {
  return (
    <svg
      id="australia-dots"
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="0 0 200 200"
      className={className}
      width={150}
      height={150}
    >
      <defs>
        {/* Animated gradient background */}
        <radialGradient id="australia-gradient" cx="50%" cy="50%" r="70%">
          <stop offset="0%" stopColor="#f89c6b">
            <animate
              attributeName="stop-color"
              values="#ffffff#f89c6b;#ed8747;#f89c6b"
              dur="4s"
              repeatCount="indefinite"
            />
          </stop>
          <stop offset="100%" stopColor="#52b773">
            <animate
              attributeName="stop-color"
              values="#ffffff#52b773;#27f49d;#52b773"
              dur="4s"
              repeatCount="indefinite"
            />
          </stop>
        </radialGradient>
        <mask id="australia-dots-mask">
          <rect width="200" height="200" fill="black" />
          <circle cx="105" cy="72" r="5.5" fill="white" />
          <circle cx="91" cy="72" r="5.5" fill="white" />
          <circle cx="77" cy="72" r="5.5" fill="white" />
          <circle cx="120" cy="72" r="5.5" fill="white" />
          <circle cx="120" cy="87" r="5.5" fill="white" />
          <circle cx="135" cy="87" r="5.5" fill="white" />
          <circle cx="135" cy="102" r="5" fill="white" />
          <circle cx="105" cy="87" r="5" fill="white" />
          <circle cx="91" cy="87" r="5" fill="white" />
          <circle cx="77" cy="87" r="5" fill="white" />
          <circle cx="63" cy="72" r="5" fill="white" />
          <circle cx="105" cy="58" r="5" fill="white" />
          <circle cx="91" cy="58" r="5" fill="white" />
          <circle cx="77" cy="58" r="5" fill="white" />
          <circle cx="63" cy="58" r="4.5" fill="white" />
          <circle cx="49" cy="72" r="4.5" fill="white" />
          <circle cx="135" cy="72" r="4.5" fill="white" />
          <circle cx="49" cy="87" r="4.5" fill="white" />
          <circle cx="63" cy="87" r="4.5" fill="white" />
          <circle cx="150" cy="87" r="4.5" fill="white" />
          <circle cx="120" cy="102" r="4.5" fill="white" />
          <circle cx="150" cy="102" r="4.5" fill="white" />
          <circle cx="120" cy="58" r="4" fill="white" />
          <circle cx="35" cy="72" r="4" fill="white" />
          <circle cx="164" cy="143" r="4" fill="white" />
          <circle cx="150" cy="143" r="4" fill="white" />
          <circle cx="164" cy="129" r="4" fill="white" />
          <circle cx="150" cy="129" r="4" fill="white" />
          <circle cx="35" cy="87" r="4" fill="white" />
          <circle cx="164" cy="116" r="4" fill="white" />
          <circle cx="150" cy="116" r="4" fill="white" />
          <circle cx="135" cy="116" r="4" fill="white" />
          <circle cx="120" cy="116" r="4" fill="white" />
          <circle cx="164" cy="102" r="4" fill="white" />
          <circle cx="105" cy="102" r="4" fill="white" />
          <circle cx="91" cy="102" r="4" fill="white" />
          <circle cx="77" cy="102" r="4" fill="white" />
          <circle cx="63" cy="102" r="4" fill="white" />
          <circle cx="49" cy="102" r="4" fill="white" />
          <circle cx="35" cy="102" r="3.5" fill="white" />
          <circle cx="150" cy="72" r="4" fill="white" />
          <circle cx="91" cy="45" r="4" fill="white" />
          <circle cx="135" cy="59" r="4" fill="white" />
          <circle cx="135" cy="129" r="3.5" fill="white" />
          <circle cx="77" cy="45" r="4" fill="white" />
          <circle cx="49" cy="60" r="3" fill="white" />
          <circle cx="164" cy="88" r="4" fill="white" />
          <circle cx="105" cy="116" r="4" fill="white" />
          <circle cx="178" cy="130" r="4.5" fill="white" />
          <circle cx="178" cy="116" r="4.5" fill="white" />
          <circle cx="63" cy="116" r="4.5" fill="white" />
          <circle cx="49" cy="116" r="4.5" fill="white" />
          <circle cx="21" cy="87" r="4" fill="white" />
          <circle cx="21" cy="73" r="4" fill="white" />
          <circle cx="105" cy="45" r="4.5" fill="white" />
          <circle cx="63" cy="45" r="4.5" fill="white" />
          <circle cx="135" cy="144" r="3.5" fill="white" />
          <circle cx="178" cy="102" r="3.5" fill="white" />
          <circle cx="120" cy="130" r="3.5" fill="white" />
          <circle cx="91" cy="116" r="3.5" fill="white" />
          <circle cx="77" cy="116" r="3.5" fill="white" />
          <circle cx="35" cy="116" r="3" fill="white" />
          <circle cx="21" cy="102" r="3" fill="white" />
          <circle cx="150" cy="59" r="3" fill="white" />
          <circle cx="164" cy="158" r="3" fill="white" />
          <circle cx="150" cy="158" r="3" fill="white" />
          <circle cx="178" cy="145" r="3.5" fill="white" />
          <circle cx="164" cy="179" r="3.5" fill="white" />
          <circle cx="178" cy="88" r="3.5" fill="white" />
          <circle cx="164" cy="73" r="2.5" fill="white" />
          <circle cx="93" cy="31" r="3" fill="white" />
          <circle cx="120" cy="45" r="3" fill="white" />
          <circle cx="21" cy="116" r="2.5" fill="white" />
          <circle cx="135" cy="45" r="2.5" fill="white" />
          <circle cx="105" cy="132" r="3" fill="white" />
          <circle cx="150" cy="45" r="3" fill="white" />
          <circle cx="35" cy="61" r="3" fill="white" />
          <circle cx="120" cy="146" r="2.5" fill="white" />
          <circle cx="135" cy="160" r="2.5" fill="white" />
          <circle cx="7" cy="89" r="2.5" fill="white" />
          <circle cx="49" cy="45" r="2.5" fill="white" />
          <circle cx="49" cy="132" r="2.5" fill="white" />
          <circle cx="191" cy="116" r="2.5" fill="white" />
          <circle cx="164" cy="62" r="2" fill="white" />
          <circle cx="10" cy="76" r="2" fill="white" />
          <circle cx="181" cy="76" r="2" fill="white" />
          <circle cx="81" cy="33" r="2" fill="white" />
          <circle cx="109" cy="33" r="2" fill="white" />
          <circle cx="150" cy="33" r="2" fill="white" />
          <circle cx="156" cy="192" r="2" fill="white" />
          <circle cx="178" cy="161" r="2" fill="white" />
          <circle cx="63" cy="132" r="2" fill="white" />
          <circle cx="35" cy="132" r="2" fill="white" />
          <circle cx="21" cy="132" r="2" fill="white" />
          <circle cx="6" cy="104" r="2" fill="white" />
          <circle cx="21" cy="61" r="2" fill="white" />
          <circle cx="138" cy="33" r="2" fill="white" />
          <circle cx="63" cy="33" r="2" fill="white" />
          <circle cx="192" cy="90" r="1.5" fill="white" />
          <circle cx="192" cy="132" r="1.5" fill="white" />
          <circle cx="150" cy="180" r="1.5" fill="white" />
        </mask>
      </defs>
      <rect
        width="200"
        height="200"
        fill="url(#australia-gradient)"
        mask="url(#australia-dots-mask)"
      />
    </svg>
  );
};
